export default function PersonnesConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('personnes');
    $translatePartialLoaderProvider.addPart('utilisateurs');
}

PersonnesConfiguration.$inject = ['$translatePartialLoaderProvider'];
